<template>
  <div v-show="isResourceContentViewActiveLocal" ref="whole_page">
    <div v-if="!selectedFolder.id" class="vx-row limit-width_fixed-scalable">
      <div class="vx-col mb-3" vs-lg="4" style="margin-top:8px">
        <span style="font-size: 18pt;font-weight: 100;color:white;">
          You have selected:
        </span>
      </div>
      <div class="vx-col" vs-lg="4" style="margin:auto">
        <vx-card class="glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="FolderIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToSelectCategory">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedCategory.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToSelectResource">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedResource.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="mt-8">
      <ul style="margin-top: 1rem;flex-wrap: wrap;">
        <div class="limit-width_fixed-scalable" style="text-align: left;">
          <li v-if="isStudent && hasTasksInStructuredLesson" class="my-4">
            <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text input-group_prepend-slot-bg">
                    <span
                      ><feather-icon
                        class="pt-1"
                        icon="GridIcon"
                        svg-classes="stroke-current"
                      ></feather-icon
                    ></span>
                  </div>
                </template>

                <vs-button
                  ref="continueWatchingBtn"
                  size="large"
                  class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                  style="border-radius:0 7px 7px 0"
                  @click="goToLesson"
                >
                  Go To Structured Lesson
                </vs-button>
              </vx-input-group>
            </vx-card>
          </li>
          <li v-else-if="!isStudent" class="my-4">
            <vx-card
              class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color"
            >
              <vx-input-group>
                <template slot="prepend">
                  <div
                    class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient"
                    style="width: 70px;"
                  >
                    <span
                      ><feather-icon
                        class="pt-1 ml-3"
                        icon="GridIcon"
                        svg-classes="stroke-current"
                      ></feather-icon
                    ></span>
                  </div>
                </template>

                <vs-button
                  :disabled="true"
                  size="large"
                  class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
                  style="border-radius:0 7px 7px 0;"
                  color=""
                >
                  Manage Structured Lesson
                </vs-button>
                <div v-if="!selectedFolder.id" class="fab_direction-up__manageSL">
                  <div class="float-btn-group">
                    <button
                      class="btn-float btn-triger school-primary_gradient"
                      @click="openManageSLMenu"
                    >
                      <i class="icon feather icon-more-horizontal text-white" />
                    </button>
                    <div class="btn-list">
                      <a
                        class="btn-float dc_dark-purple description glow-effect_dark"
                        @click="goToBuilder"
                      >
                        <span class="descriptiontext">Add/Edit</span>
                        <i class="icon feather icon-edit text-white" />
                      </a>
                      <a v-show="selectedResource.startTaskDisplayId"
                        class="btn-float dc_dark-purple description glow-effect_dark"
                        @click="goToLesson"
                      >
                        <span class="descriptiontext">Preview</span>
                        <i class="icon feather icon-play text-white" />
                      </a>
                    </div>
                  </div>
                </div>
                <div v-else class="fab_direction-down__manageSL">
                  <div class="float-btn-group">
                    <button
                      class="btn-float btn-triger school-primary_gradient"
                      @click="openManageSLMenu"
                    >
                      <i class="icon feather icon-more-horizontal text-white" />
                    </button>
                    <div class="btn-list">
                      <a
                        class="btn-float dc_dark-purple description glow-effect_dark"
                        @click="goToBuilder"
                      >
                        <span class="descriptiontext">Add/Edit</span>
                        <i class="icon feather icon-edit text-white" />
                      </a>
                      <a
                        v-show="selectedResource.startTaskDisplayId"
                        class="btn-float dc_dark-purple description glow-effect_dark"
                        @click="goToLesson"
                      >
                        <span class="descriptiontext">Preview</span>
                        <i class="icon feather icon-play text-white" />
                      </a>
                    </div>
                  </div>
                </div>
              </vx-input-group>
            </vx-card>
          </li>
        </div>
        <div>
          <div v-if="numberOfTasks > 0" class="limit-width_fixed-scalable" style="text-align: left;">
            <li>
              <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 410px"
              >
                <vx-input-group>
                  <vs-button
                    :disabled="true"
                    size="large"
                    class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
                    type="filled"
                    color=""
                  >
                    Select an item in the Folder
                  </vs-button>
                </vx-input-group>
              </vx-card>
            </li>
          </div>

          <li v-for="(_task, index) in standaloneContent.tasks" :key="index" class="mb-4">
            <vx-card
              class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color"
            >
              <vx-input-group>
                <template slot="prepend">
                  <vs-button
                    v-if="_task.isNew"
                    :disabled="true"
                    id="new-content"
                    size="small"
                    radius
                    color="#4e5c9a"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-star"
                    class="button__fully-opaque glow-effect_light"
                  ></vs-button>
                  <div
                    class="prepend-text glow-effect_dark limit-height_content-height input-group_prepend-slot-bg"
                    style="width: 70px;border-radius: 5px 0 0 5px !important;"
                  >
                    <span
                      ><feather-icon
                        class="pt-1 ml-3"
                        :icon="getIcon(_task)"
                        svg-classes="stroke-current"
                      ></feather-icon
                    ></span>
                  </div>
                </template>

                <vs-button
                  size="large"
                  class="w-full glow-effect_primary limit-height_content-height button-text__left-align school-primary_gradient"
                  style="border-radius:0 7px 7px 0;"
                  @click="contentSelected(_task)"
                >
                  {{ _task.index + 1 }}) {{ getContentName(_task) }}
                  <p class="pt-1" v-if="_task.liveStream">
                    <strong><small>{{ formatDate(_task.liveStream.date) + " " + _task.liveStream.startTime + " - " + _task.liveStream.endTime }}</small></strong>
                  </p>
                  <p class="pt-1" v-else-if="_task.videoChat">
                    <strong><small>{{ formatDate(_task.videoChat.date) + " " + _task.videoChat.startTime + " - " + _task.videoChat.endTime }}</small></strong>
                  </p>
                </vs-button>
                <div v-if="!isStudent && _task.siteId == $getSiteId()">
                  <div class="fab_inline--button">
                    <div class="float-btn-group">
                      <button
                        class="btn-float btn-triger input-group_prepend-slot-bg"
                        @click="openActions"
                      >
                        <i
                          class="icon feather icon-more-horizontal text-white"
                        />
                      </button>
                      <div class="btn-list">
                        <a
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="moveTaskUp(_task)"
                        >
                          <i
                            v-if="_task.index > 0"
                            class="icon feather icon-arrow-up-circle text-white"
                          ></i>
                        </a>
                        <a
                          v-show="!(_task.liveStream || _task.videoChat)"
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="editTask(_task)"
                        >
                          <i class="icon feather icon-edit text-white"></i>
                        </a>
                        <a
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="moveTaskDown(_task)"
                        >
                          <i
                            v-if="
                              _task.index < standaloneContent.tasks.length - 1
                            "
                            class="icon feather icon-arrow-down-circle text-white"
                          ></i>
                        </a>
                        <a
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="deleteTask(_task)"
                        >
                          <i
                            class="icon feather icon-trash-2 text-danger"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </vx-input-group>
            </vx-card>
          </li>
        </div>
        <vx-card
          v-if="!isStudent"
          card-background="#11193f"
          class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding mt-4"
        >
          <vx-input-group>
            <template slot="prepend">
              <div
                class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient"
                style="width: 70px;"
              >
                <span
                  ><feather-icon
                    class="pt-1 ml-3"
                    icon="ArrowRightIcon"
                    svg-classes="stroke-current"
                  ></feather-icon
                ></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
              style="border-radius:0 7px 7px 0;"
              color=""
            >
              {{ numberOfTasks == 0 ? "Or, Add Some Standalone Content" : "Add an Item" }}
            </vs-button>
            <div v-if="isAddVisible" class="fab_direction-down__tasks">
              <div class="float-btn-group">
                <button
                  class="btn-float btn-triger school-primary_gradient"
                  @click="openTasksMenu"
                >
                  <i class="icon feather icon-plus-circle text-white" />
                </button>
                <div class="btn-list">
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(4)"
                  >
                    <span class="descriptiontext">Add a Quiz</span>
                    <i class="icon feather icon-edit text-white"></i>
                  </a>
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(3)"
                  >
                    <span class="descriptiontext">Add a Podcast</span>
                    <i class="icon feather icon-mic text-white" />
                  </a>
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(2)"
                  >
                    <span class="descriptiontext">Add a Document</span>
                    <i class="icon feather icon-file-text text-white" />
                  </a>
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(1)"
                  >
                    <span class="descriptiontext">Add a Video</span>
                    <i class="icon feather icon-youtube text-white"></i>
                  </a>
                </div>
              </div>
            </div>
          </vx-input-group>
        </vx-card>
        <p
          v-show="showComingSoon && isStudent"
          style="color:white;font-weight:500;font-size:16px;padding-top:5px"
        >
          Watch this space! Content coming soon...
        </p>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  components: {
    moment
  },
  data() {
    return {
      standaloneContent: {},
      showComingSoon: false,
      fabElement: null,
      numberOfTasks: null,
      allSelectedData: {},
      isAddVisible: true,
      hasTasksInStructuredLesson: false
    };
  },
  props: {
    isResourceContentViewActive: {
      required: false
    },
    isStudent: {
      type: Boolean,
      required: false
    },
    selectedCategory: {
      type: Object,
      required: false
    },
    selectedResource: {
      type: Object,
      required: false
    },
    isTeacher: {
      type: Boolean,
      required: false
    },
    selectedFolder: {
      type: Object,
      required: false
    },
    selectedFolders: {
      type: Array,
      required: false
    }
  },
  watch: {
    isResourceContentViewActive: function(val) {
      if (val) {
        var self = this;
        self.allSelectedData = {
          selectedCategory: self.selectedCategory,
          selectedResource: self.selectedResource
        };

        self.getStandaloneContent();
      }
    }
  },
  computed: {
    isResourceContentViewActiveLocal: {
      get() {
        return this.isResourceContentViewActive;
      }
    }
  },
  methods: {
    initValues() {
      this.standaloneContent = [];
    },
    getStandaloneContent() {
      var self = this;
      self.showComingSoon = false;

      var topicId = self.selectedResource.topicId;

      if (self.isStudent) {
        self.showComingSoon = false;
        self.showLoadingOnElement("whole_page", 1, "material");

        var onSuccess = function(response) {
          self.hasTasksInStructuredLesson = response.data.hasTasksInStructuredLesson;
          if (response.data && response.data.tasks.length >= 0) {
            self.standaloneContent = response.data;
          }
          self.showComingSoon = self.standaloneContent.tasks.length == 0 ? true : false;
        };

        var onFinally = function(response) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
          self.numberOfTasks = self.standaloneContent ? self.standaloneContent.tasks.length : 0;
        };

        self.$ajaxGetAnon(self,"Module/GetStandaloneContent?topicId=" +topicId +"&siteId=" +self.$getSiteId()+"&userId=" + localStorage.getItem("Current_User_Id"), onSuccess,onFinally);
      } else {
        self.showComingSoon = false;
        self.showLoadingOnElement("whole_page", 1, "material");

        var onSuccess = function(response) {
          if (response.data && response.data.tasks.length >= 0) {
            self.standaloneContent = response.data;
          }
          self.showComingSoon = self.standaloneContent.tasks.length == 0 ? true : false;
        };

        var onFinally = function(response) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
          self.numberOfTasks = self.standaloneContent ? self.standaloneContent.tasks.length : 0;
        };

        self.$ajaxGetAnon(self, "Module/Admin/GetStandaloneContent?topicId=" + topicId + "&siteId=" + self.$getSiteId(), onSuccess, onFinally);
      }
    },
    contentSelected(task) {
      var self = this;

      localStorage.setItem("selectedCategory", self.selectedCategory.id);
      localStorage.setItem("selectedResource", self.selectedResource.topicId);

      if (self.selectedFolders.length > 0) {
        localStorage.setItem("selectedFolders", JSON.stringify(self.selectedFolders));
      }

      var selectedTopic = {
        id: self.selectedResource.topicId,
        name: self.selectedResource.name
      };

      var selectedData = {
        selectedCategory: self.selectedCategory,
        selectedTopic: selectedTopic
      };

      self.$emit(
        "contentSelected",
        task,
        task.index,
        self.standaloneContent,
        selectedData
      );
    },
    goToLesson() {
      var self = this;

      var selectedData = {
        selectedCategory: self.selectedCategory,
        selectedResource: self.selectedResource
      };
      localStorage.setItem("selectedCategory", selectedData.selectedCategory.id);
      localStorage.setItem("selectedResource", selectedData.selectedResource.topicId);
      localStorage.setItem("selectedData", JSON.stringify(selectedData));

      if (self.selectedFolders.length > 0) {
        localStorage.setItem("selectedFolders", JSON.stringify(self.selectedFolders));
      }

      var moduleId = self.selectedResource.topicId;
      var taskDisplayId = self.selectedResource.startTaskDisplayId;

      var lastTask = localStorage.getItem("lastTask");
      var lastModule = localStorage.getItem("lastModule");

      if (lastModule && lastModule.toString() == moduleId.toString()) {
        if (lastTask) {
          moduleId = lastModule;
          taskDisplayId = lastTask;
        }
      }

      localStorage.setItem("currentModule", moduleId);
      self.$router.push({
        name: "DigiStoryViewer",
        params: {
          mode: "story",
          taskDisplayId: taskDisplayId,
          moduleId: moduleId,
          isStudent: "true"
        },
        query:{ref: "resources"}
      });
    },
    addContent(type) {
      // 1: video, 2: document
      var self = this;
      self.closeTasksMenu();
      var selectedData = {
        selectedCategory: self.selectedCategory,
        selectedResource: self.selectedResource
      };

      localStorage.setItem("selectedCategory", this.selectedCategory.id);
      localStorage.setItem("selectedResource", this.selectedResource.topicId);

      if (self.selectedFolders.length > 0) {
        localStorage.setItem("selectedFolders", JSON.stringify(self.selectedFolders));
      }

      if (type == 1)
        self.$router.push({
          name: "AddVideo",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher,
            isResourceContent: true
          }
        });
      else if (type == 2)
        self.$router.push({
          name: "AddDocument",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher,
            isResourceContent: true
          }
        });
      else if (type == 3)
        self.$router.push({
          name: "AddPodcast",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher,
            isResourceContent: true
          }
        });
      else if (type == 4)
        self.$router.push({
          name: "AddQuiz",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher,
            isResourceContent: true
          }
        });
    },
    backToSelectCategory() {
      this.initValues();
      this.$emit("backToSelectCategory");
    },
    backToSelectResource() {
      this.initValues();
      this.$emit("backToSelectResource");
    },
    formatDate(date) {
      var self = this;
      var dateString = new Date(Date.parse(date));

      var result = moment(dateString.toISOString()).format("DD MMMM YYYY");
      return result;
    },
    getIcon(task) {
      if (task.video) return "YoutubeIcon";
      else if (task.document) return "FileTextIcon";
      else if (task.podcast) return "MicIcon";
      else if (task.quiz) return "EditIcon";
    },
    getContentName(task) {
      if (task.video) return task.video.name;
      else if (task.document) return task.document.name;
      else if (task.podcast) return task.podcast.name;
      else if (task.quiz) return task.quiz.name;
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    openManageSLMenu(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      
      if (this.selectedFolder.id) {
        if (this.fabElement.classList.contains("open")) {
          setTimeout(() => {
            this.isAddVisible = true;
          }, 300);
        } else {
          setTimeout(() => {
            this.isAddVisible = false;
          }, 200);
        }
      }

      if (this.fabElement) {
        this.fabElement.classList.toggle("open");
      }
    },
    closeManageSLMenu() {
      if (this.fabElement) {
        this.fabElement.classList.remove("open");
      }
    },
    openTasksMenu(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle("open");
      }
    },
    closeTasksMenu() {
      if (this.fabElement) {
        this.fabElement.classList.remove("open");
      }
    },
    openActions(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle("open");
      }
    },
    closeActions() {
      if (this.fabElement) {
        this.fabElement.classList.remove("open");
      }
    },
    editTask(task) {
      var self = this;

      var selectedData = {
        selectedCategory: self.selectedCategory,
        selectedResource: self.selectedResource
      };

      localStorage.setItem("selectedCategory", this.selectedCategory.id);
      localStorage.setItem("selectedResource", this.selectedResource.topicId);

      if (self.selectedFolders.length > 0) {
        localStorage.setItem("selectedFolders", JSON.stringify(self.selectedFolders));
      }

      if (task.video)
        self.$router.push({
          name: "EditVideo",
          params: {
            selectedData: selectedData,
            videoTask: task,
            isTeacher: self.isTeacher,
            isResourceContent: true
          }
        });
      else if (task.document)
        self.$router.push({
          name: "EditDocument",
          params: {
            selectedData: selectedData,
            documentTask: task,
            isTeacher: self.isTeacher,
            isResourceContent: true
          }
        });
      else if (task.podcast)
        self.$router.push({
          name: "EditPodcast",
          params: {
            selectedData: selectedData,
            podcastTask: task,
            isTeacher: self.isTeacher,
            isResourceContent: true
          }
        });
      else if (task.quiz)
        self.$router.push({
          name: "EditQuiz",
          params: {
            selectedData: selectedData,
            quizTask: task,
            isTeacher: self.isTeacher,
            isResourceContent: true
          }
        });
    },
    deleteTask(task) {
      var self = this;
      self.closeActions();
      var taskType = "";

      var onSuccess = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: `${taskType} Deleted`,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-trash",
          time: 5500
        });
        self.getStandaloneContent();
      };

      var onFinally = function() {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      if (task.video) {
        self.showLoadingOnElement("whole_page", 1, "material");
        taskType = "Video";
        self.$ajaxGet(
          self,
          "VideoTask/Delete/" + task.id,
          onSuccess,
          onFinally
        );
      } else if (task.document) {
        self.showLoadingOnElement("whole_page", 1, "material");
        taskType = "Document";
        self.$ajaxGet(
          self,
          "DocumentTask/Delete/" + task.id,
          onSuccess,
          onFinally
        );
      } else if (task.podcast) {
        self.showLoadingOnElement("whole_page", 1, "material");
        taskType = "Podcast";
        self.$ajaxGet(
          self,
          "PodcastTask/Delete/" + task.id,
          onSuccess,
          onFinally
        );
      }
    },
    moveTaskUp(task) {
      var self = this;
      self.closeActions();
      self.showLoadingOnElement("whole_page", 1, "material");

      var onSuccess = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
        self.getStandaloneContent();
      };

      self.$ajaxGet(self, "Module/MoveTaskUp?moduleId=" + self.selectedResource.topicId + "&index=" + task.number, onSuccess);
    },
    moveTaskDown(task) {
      var self = this;
      self.closeActions();
      self.showLoadingOnElement("whole_page", 1, "material");

      var onSuccess = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
        self.getStandaloneContent();
      };

      self.$ajaxGet(self,"Module/MoveTaskDown?moduleId=" + self.selectedResource.topicId + "&index=" + task.number, onSuccess);
    },
    goToBuilder() {
      var self = this;
      self.closeTasksMenu();
      localStorage.setItem("currentModule", self.selectedResource.topicId);
      localStorage.setItem("selectedCategory", self.selectedCategory.id);
      localStorage.setItem("selectedResource", self.selectedResource.topicId);
      localStorage.setItem(
        "selectedData",
        JSON.stringify(self.allSelectedData)
      );
      // self.$router.push({ name: 'DigiCourseBuilder' });
      let routeData = self.$router.resolve({ name: "DigiCourseBuilder", query:{ref: "resources"} });
      window.open(routeData.href, "_self");
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.fab_inline--button {
  right: 0.5vw;
  bottom: 1.5vh;
  z-index: 999;
  position: absolute;
}

.fab_direction-down__tasks,
.fab_direction-up__tasks {
  right: 0.9vw;
  bottom: 0.7vh;
  z-index: 999;
  position: absolute;
}

.fab_direction-down__manageSL,
.fab_direction-up__manageSL {
  right: 0.9vw;
  bottom: 0.7vh;
  z-index: 999;
  position: absolute;
}
</style>

<style lang="scss">
.popup_class .vs-popup {
  background: rgb(65, 71, 94) !important;
  color: rgb(202, 202, 202) !important;
  > header.vs-popup--header {
    background: rgb(38, 45, 74) !important;

    > div.vs-popup--title > h3 {
      color: rgb(255, 255, 255) !important;
    }
  }

  .vs-popup--content {
    height: inherit !important;
  }
}

#school_logo_img {
  width: 50px;
  height: 50px;
}
</style>
